import styled from "styled-components";

export const GlobalStyle = styled.div`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  @import url('https://fonts.googleapis.com/css2?family=Raleway:wght@600&display=swap');
  @import url('https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css');
`;

export const HeroSection = styled.section`
  position: relative;
  width: 100vw;
  min-height: 77vh;
  overflow: hidden;
  font-family: Raleway;
  padding: 20vw 6vw;
  left: 0;
  z-index: 1;

  /* Tablet */
  @media (min-width: 768px) {
    padding: 15vw 5vw;
    min-height: 90vh;
  }

  /* Desktop */
  @media (min-width: 1024px) {
    height: 80.08vw;
    padding: 10.15vw 4.32vw;
    left: -0.052vw;
    width: 100.06vw;
  }
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  position: relative;
  z-index: 10;

  /* Desktop */
  @media (min-width: 1024px) {
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
  }
`;

export const LeftContent = styled.div`
  flex: 1;
  margin-left: 0;
  margin-top: 0;
  text-align: center;
  width: 100%;

  /* Tablet */
  @media (min-width: 768px) {
    margin-top: 2%;
    padding: 0 5vw;
  }

  /* Desktop */
  @media (min-width: 1024px) {
    margin-left: 1.50vw;
    margin-top: 6%;
    text-align: left;
    padding: 0;
  }
`;

export const Title = styled.h1`
  font-family: Raleway;
  font-size: 8vw;
  font-weight: 600;
  line-height: 110%;
  margin-bottom: 5vw;
  background: linear-gradient(107.93deg, #FFFFFF -2.39%, rgba(255, 61, 0, 0.69) 92.36%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  display: flex;
  flex-direction: column;

  /* Tablet */
  @media (min-width: 768px) {
    font-size: 6vw;
    margin-bottom: 4vw;
  }

  /* Desktop */
  @media (min-width: 1024px) {
    font-size: 4.1667vw;
    line-height: 100%;
    margin-bottom: 2.08vw;
    height: 8.34vw;
    overflow: hidden;
  }
`;

export const TitleLine1 = styled.span`
  display: block;
  line-height: 1.1;

  @media (min-width: 1024px) {
    line-height: 1;
  }
`;

export const TitleLine2 = styled.span`
  display: block;
  line-height: 1.1;

  @media (min-width: 1024px) {
    line-height: 1;
  }
`;

export const Description = styled.p`
  color: #b8b8c7;
  font-size: 4vw;
  line-height: 1.6;
  margin-bottom: 6vw;
  padding: 0 2vw;

  br {
    display: none;
  }

  /* Tablet */
  @media (min-width: 768px) {
    font-size: 2.5vw;
    margin-bottom: 5vw;
    max-width: 70vw;
    margin-left: auto;
    margin-right: auto;
  }

  /* Desktop */
  @media (min-width: 1024px) {
    font-size: 1.3021vw;
    max-width: 28.65vw;
    margin-bottom: 2.6vw;
    padding: 0;
    margin-left: 0;
    margin-right: 0;

    br {
      display: block;
    }
  }
`;

export const Buttons = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3vw;
  align-items: center;
  width: 100%;

  /* Tablet */
  @media (min-width: 768px) {
    flex-direction: row;
    gap: 2vw;
    justify-content: center;
  }

  /* Desktop */
  @media (min-width: 1024px) {
    gap: 1.25vw;
    align-items: flex-start;
    justify-content: flex-start;
  }
`;

export const StyledButton = styled.button`
  padding: 0;
  font-size: 3.5vw;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  border: none;
  display: flex;
  align-items: center;
  gap: 2vw;
  justify-content: center;
  width: 80vw;
  height: 12vw;

  i {
    font-size: 3.5vw;
  }

  /* Tablet */
  @media (min-width: 768px) {
    width: 35vw;
    height: 10vw;
    font-size: 2vw;
    gap: 1.5vw;

    i {
      font-size: 2vw;
    }
  }

  /* Desktop */
  @media (min-width: 1024px) {
    width: 14.52vw;
    height: 4.34vw;
    font-size: 0.94vw;
    gap: 0.52vw;

    i {
      font-size: 0.94vw;
    }
  }

  &.btn-primary {
    background: linear-gradient(90deg, #FFFFFF 0%, rgba(255, 255, 255, 0.25) 100%);
    backdrop-filter: blur(10px);
    color: #000000;
    border-top-left-radius: 6vw;
    border-top-right-radius: 1vw;
    border-bottom-right-radius: 6vw;
    border-bottom-left-radius: 1vw;
    box-shadow: 
      0px 0.5vw 1vw 0px rgba(24, 167, 185, 0.1),
      0px 1vw 2vw 0px rgba(24, 167, 185, 0.15);

    @media (min-width: 1024px) {
      border-top-left-radius: 2.08vw;
      border-top-right-radius: 0.26vw;
      border-bottom-right-radius: 2.08vw;
      border-bottom-left-radius: 0.26vw;
      box-shadow: 
        0px 0.096vw 0.164vw 0px rgba(24, 167, 185, 0.02),
        0px 0.424vw 0.34vw 0px rgba(24, 167, 185, 0.04),
        0px 1.04vw 0.677vw 0px rgba(24, 167, 185, 0.05),
        0px 2.006vw 1.327vw 0px rgba(24, 167, 185, 0.06),
        0px 3.375vw 2.44vw 0px rgba(24, 167, 185, 0.07);
    }

    &:hover {
      background: linear-gradient(90deg, #FFFFFF 0%, rgba(255, 255, 255, 0.35) 100%);
      transform: translateY(-0.5vw);

      @media (min-width: 1024px) {
        transform: translateY(-0.104vw);
      }
    }
  }

  &.btn-secondary {
    background: transparent;
    color: #ffffff;
    border-top-left-radius: 1vw;
    border-top-right-radius: 6vw;
    border-bottom-right-radius: 1vw;
    border-bottom-left-radius: 6vw;
    position: relative;

    @media (min-width: 1024px) {
      border-top-left-radius: 0.26vw;
      border-top-right-radius: 2.08vw;
      border-bottom-right-radius: 0.26vw;
      border-bottom-left-radius: 2.08vw;
    }

    &::before {
      content: '';
      position: absolute;
      inset: 0;
      border-radius: inherit;
      padding: 0.3vw;
      background: linear-gradient(268.92deg, #FFEE94 -15.35%, rgba(255, 255, 255, 0) 117.59%);
      -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
      -webkit-mask-composite: xor;
      mask-composite: exclude;
      pointer-events: none;

      @media (min-width: 1024px) {
        padding: 0.078vw;
      }
    }

    &:hover {
      background: rgba(255, 255, 255, 0.05);
    }
  }
`;

export const ImagesContainer = styled.div`
  display: none; /* Caché sur mobile */

  /* Desktop uniquement */
  @media (min-width: 1024px) {
    display: block;
    position: relative;
    width: 54.73vw;
    height: 54.73vw;
    overflow: visible;
    margin-right: -10.42vw;
    padding-top: 17%;
  }
`;

export const LargeCircle = styled.div`
  position: absolute;
  width: 56.73vw;
  height: 54.73vw;
  top: -10%;
  left: 0;
  z-index: 5;
  
  svg {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;

export const LargeCircleOverlay = styled.div`
  position: absolute;
  width: 54.73vw;
  height: 54.73vw;
  top: -10%;
  left: 0;
  z-index: 6;
  
  background: linear-gradient(
    90deg,
    transparent 0%,
    transparent 92%,
    #060622 92%,
    #060622 100%
  );
  pointer-events: none;
`;

export const ImageCircle = styled.div`
  position: absolute;
  overflow: visible;
  z-index: 7;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }

  &.photo1 {
    width: 12.32vw;
    height: 12.32vw;
    top: 21.99vw;
    left: 8.326vw;
  }

  &.photo2 {
    width: 14.45vw;
    height: 20.41vw;
    top: 4.04vw;
    left: 16.24vw;
    transform: rotate(-4.53deg);
  }

  &.photo3 {
    width: 10.38vw;
    height: 10.38vw;
    top: 25.1vw;
    left: 20.39vw;
  }

  &.photo4 {
    width: 11.13vw;
    height: 21.13vw;
    top: 10.91vw;
    left: 31.9vw;
  }

  &.photo5 {
    width: 10.38vw;
    height: 10.38vw;
    top: 0.466vw;
    left: 32.27vw;
  }
`;

export const SignatureContainer = styled.div`
  display: none; /* Caché sur mobile */

  /* Desktop uniquement */
  @media (min-width: 1024px) {
    display: block;
    position: absolute;
    width: 70.26vw;
    height: 43.44vw;
    top: 6.15vw;
    left: -0.416vw;
    z-index: 1000;
    
    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }
`;

export const CoinImage = styled.div`
  display: none; /* Caché sur mobile */

  /* Desktop uniquement */
  @media (min-width: 1024px) {
    display: block;
    position: absolute;
    width: 18.61vw;
    height: 31.92vw;
    top: -8.44vw;
    left: 2.78vw;
    z-index: 0;
    
    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }
`;

export const Ellipse5Image = styled.div`
  display: none; /* Caché sur mobile */

  /* Desktop uniquement */
  @media (min-width: 1024px) {
    display: block;
    position: absolute;
    width: 3.16vw;
    height: 3.16vw;
    top: 12.39vw;
    left: 8.87vw;
    z-index: 1001;
    border-radius: 50%;
    
    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }
`;

export const PolygonImage = styled.div`
  display: none; /* Caché sur mobile */

  /* Desktop uniquement */
  @media (min-width: 1024px) {
    display: block;
    position: absolute;
    width: 4.31vw;
    height: 4.56vw;
    top: 20.08vw;
    left: 61.60vw;
    z-index: 1001;
    
    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }
`;

export const Ellipse7Image = styled.div`
  display: none; /* Caché sur mobile */

  /* Desktop uniquement */
  @media (min-width: 1024px) {
    display: block;
    position: absolute;
    width: 1.94vw;
    height: 1.94vw;
    top: 9.08vw;
    left: 74.04vw;
    z-index: 1001;
    border-radius: 50%;
    
    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }
`;

export const Ellipse4Image = styled.div`
  display: none; /* Caché sur mobile */

  /* Desktop uniquement */
  @media (min-width: 1024px) {
    display: block;
    position: absolute;
    width: 1.94vw;
    height: 1.94vw;
    top: 44.58vw;
    left: 94.93vw;
    z-index: 1001;
    border-radius: 50%;
    
    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }
`;